export const gizmoOptions = [
    {value: 'translate', label: 'Translate'},
    {value: 'rotate', label: 'Rotate'},
    {value: 'scale', label: 'Scale'},
]

